/* eslint-disable no-case-declarations */
import router from "@/router";
import Service from "@/api/Service";
import FilterPanel from "@/features/filters/FilterPanel.vue";
//import Vue from "vue";
//import {isEmpty} from "lodash";


//import config from "@/flyerConfig.json";

//Search debounce timeout id;
let sdid = null;

function convertApiDataToListItem(apiFilters) {
    return apiFilters.map((item) => {
        if(!!item?.label && !!item?.checkbox) return item;
        const label = (typeof item === 'string') ? item : item?.titleEn;
        let subItems = (Array.isArray(item?.subcategories) ? convertApiDataToListItem(item.subcategories): []).filter((item) => {
            return !!item.label;
        });

        subItems = subItems.length? subItems: null;

        return {
            label,
            subItems,
            checkbox: {
                selected: false
            }
        };
    })
}

function setDropDownItemsSelectState(items, state) {
    for(let i =0; i < items.length; i++){
        const item = items[i];
        item.checkbox.selected = state;
        if(item.subItems) {
            setDropDownItemsSelectState(item.subItems, state);
        }
    }
}

function parseFilterItemValue(items, v, format, sid) {
    items.forEach((item) => {
        if (item.checkbox.selected) {
            switch (format) {
                case 'boolean':
                    //Vue.set(v, item.id || item.label, true);
                    v[item.id || item.label] = true;
                    break;
                case 'single':
                    //Vue.set(v, sid, item.value || item.label)
                    v[sid] = item.value || item.label
                    break;
                default:
                    if (!v[sid]) {
                        //Vue.set(v, sid, [])
                        v[sid] = [];
                    }
                    v[sid].push(item.value || item.label)
            }
        }
        if(Array.isArray(item.subItems) && sid === 'category') {
            parseFilterItemValue(item.subItems, v, format, 'subCategory')
        }
    })
}


const state = {
    filterData: [],
    filterPanelDrawer: 'header',
    activeAccordionSections: [],
    filtersClearedAt: 0
}
const getters = {
    config(state, getters, rootState, rootGetters) {
        const features = rootGetters['config/features'];
        return features?.filters || [];// JSON.parse(JSON.stringify(features.filters));
    },

    filters(state, getters) {
        const fd = state.filterData;
        const config = getters.config;
        // console.log('***** Updating Filters')
        return config.map((fc) => {
            if (fc?.sections) {
                fc.sections = fc.sections.map((section) => {
                    const rdProp = section?.loadFrom || section?.name;
                    /*if(!section._items) {
                        section._items = cloneDeep(section.items);
                    }*/
                    if (fd[rdProp]) {
                        /*Vue.set(section, 'items', (section?.customItems || []).concat(convertApiDataToListItem(fd[rdProp])).sort((a, b) => {
                            return a.label.localeCompare(b.label);
                        }))*/
                        section.items = (section?.customItems || []).concat(convertApiDataToListItem(fd[rdProp])).sort((a, b) => {
                            return ((section.id === "gender")) ? 0 : a.label.localeCompare(b.label);
                        });
                    }
                    return section;
                })
            }
            return fc;
        })
    },
    activeAccordionSections(state) {
         return state.activeAccordionSections || [];
    },
    filtersClearedAt(state) {
        return state.filtersClearedAt;
    },
    hasMadeInCanadaOrQuebecProducts(state, getters, rootState){
      return rootState?.pages.some(page =>
        page?.blocks.some(block =>
          block?.products.some(product =>
              product.madeInCanada  || product.madeInQuebec)
        )
      )
    },
    hasLoyaltyProducts(_state, _getters, rootState) {
      return rootState?.pages?.some(page =>
        page?.blocks?.some(block =>
          block?.products?.some(product => !!product?.loyalty)
        )
      ) ?? false;
    },
    filtersByType(state, getters) {
        const f = {};
        getters.filters.forEach((filter) => {
            if(!filter?.type)return;
            const type = filter.type;
            if(!f[type]) {
                f[type] = [];
            }
            f[type].push(filter);
        })
        return f;
    },
    filtersByName(state, getters){
      const f = {};
      getters.filters.forEach((filter) => {
          if(!filter?.name)return;
          f[filter.name] = filter;
      })
        return f;
    },

    searchQuery(state, getters) {
        const filters = getters.filters;

        if(!filters)return [];

        const v = {};

        filters.forEach((filter) => {
            const sections = filter?.sections;
            switch(filter.type) {
                case 'dropdown':
                    if(!sections)return;
                    sections.forEach((section) => {
                        const sid = section.id;
                        const format = section?.format ?? 'array';
                        parseFilterItemValue(section.items, v, format, sid);
                        /*section.items.forEach((item) => {
                            if (item.checkbox.selected) {
                                switch (format) {
                                    case 'boolean':
                                        //Vue.set(v, item.id || item.label, true);
                                        v[item.id || item.label] = true;
                                        break;
                                    case 'single':
                                        //Vue.set(v, sid, item.value || item.label)
                                        v[sid] = item.value || item.label
                                        break;
                                    default:
                                        if (!v[sid]) {
                                            //Vue.set(v, sid, [])
                                            v[sid] = [];
                                        }
                                        v[sid].push(item.value || item.label)
                                }
                            }
                        });*/
                    })
                break;
                case 'toggle-button':
                    const fWithMultipleParams = filter?.multipleParams
                    if(fWithMultipleParams && filter.value)
                        fWithMultipleParams.forEach(param => ( v[param] = filter.value ))
                   else if(filter.value)
                        v[filter.name] = filter.value
                    break;
                case 'searchbar':
                    if(filter.value){
                        //Vue.set(v, filter.name, filter.value);
                        v[filter.query || filter.name] = filter.value;
                    }
                break;
                case 'rangeList':
                    const items = filter.items;
                     // pick the FIRST selected item (lowest range)
                    const selected = items.find(item => item.selected);
                    if(selected){
                        v[filter.query || filter.name] = selected.value;
                    }
                break;
                case 'radioList':
                    const radioSelected = filter.items.find(item => item.selected);
                    if(radioSelected && radioSelected.value !== 'relevance'){
                        v[filter.query || filter.name] = radioSelected.value;
                    }
                break;
            }
        })

        return v;
    },
    hasFilters(state, getters) {
        return !!Object.keys(getters.searchQuery).length;
    },
    drawerItems(state, getters, rootState) {
        return rootState.drawer.drawerItems;
    },
    isFilterPanelOpen(state, getters){
        const items = getters.drawerItems[state.filterPanelDrawer];
        return !!items['filters'];
    }
}
const actions = {
    async loadFlyerFilters({commit}) {
        const flyerId = router.currentRoute.params.flyerId;
        const storeId = parseInt(router.currentRoute.query?.storeId || '', 10);
        const lang = router.currentRoute.query.language === 'fr' ? 'bil' : 'en';

        const filters = await Service.GetAllFilters(flyerId, storeId, lang);
        commit('SET_FILTER_DATA', filters);
    },
    clearSort({ getters }) {
        const filters = getters.filters;
        if (!filters) return;
        const sortFilter = filters.find(f => f.type === 'radioList' && (f.query || f.name) === 'Sort');
        if (sortFilter) sortFilter.items.forEach(item => { item.selected = false; });
    },
clearRating({ getters }) {
  const filters = getters.filters;
  if (!filters) return;

  const ratingFilter = filters.find(
    f => f.type === 'rangeList' && (f.query || f.name) === 'rating'
  );

  if (ratingFilter) {
    ratingFilter.items.forEach(item => {
      item.selected = false;
    });
  }
},
    clearBrandDescriptions({ getters }) {
        const filters = getters.filters;
        if (!filters) return;
        filters.forEach((filter) => {
            if (filter.type !== 'dropdown' || !filter.sections) return;
            filter.sections.forEach((section) => {
                if (section.id === 'BrandDescriptions') {
                    setDropDownItemsSelectState(section.items, false);
                }
            });
        });
    },

    clearBrandsNotIn({ getters }, availableBrands) {
        const filters = getters.filters;
        if (!filters) return;
        filters.forEach((filter) => {
            if (filter.type !== 'dropdown' || !filter.sections) return;
            filter.sections.forEach((section) => {
                if (section.id === 'BrandDescriptions') {
                    section.items.forEach(item => {
                        if (!availableBrands.includes(item.value || item.label)) {
                            item.checkbox.selected = false;
                        }
                    });
                }
            });
        });
    },

    clearOffer({ getters }) {
        const filters = getters.filters;
        if (!filters) return;
        
        filters.forEach((filter) => {
            if (filter.type !== 'dropdown' || !filter.sections) return;
            filter.sections.forEach((section) => {
                if (section.id === 'offer') setDropDownItemsSelectState(section.items, false);
            });
        });
        
    },

    clearAllExceptOffer({ getters }) {
        const filters = getters.filters;
        if (!filters) return;
        filters.forEach((filter) => {
            const sections = filter?.sections;
            switch (filter.type) {
                case 'dropdown':
                    if (!sections) return;
                    sections.forEach((section) => {
                        if (section.id !== 'offer') setDropDownItemsSelectState(section.items, false);
                    });
                    break;
                case 'toggle-button':
                    filter.value = false;
                    break;
                case 'searchbar':
                    filter.value = '';
                    break;
                case 'rangeList':
                    filter.items.forEach(item => { item.selected = false; });
                    break;
                case 'radioList':
                    filter.items.forEach(item => { item.selected = false; });
                    break;
            }
        });
    },

    clearFilters({ dispatch, commit, getters }) {
        console.log('Clear Filters')

        dispatch("search/resetFilters", null, {root: true});

        dispatch("setTiledView", false, { root: true });
        dispatch('filters/clearAccordionSections', null, { root: true });
        commit('FILTERS_CLEARED');


        const filters = getters.filters;

        if(!filters)return;
        filters.forEach((filter) => {
            const sections = filter?.sections;

            switch(filter.type) {
                case 'dropdown':
                    if(!sections)return;
                    sections.forEach((section) => {
                        setDropDownItemsSelectState(section.items, false);
                        /*section.items.forEach((item) => {
                            item.checkbox.selected = false;
                        });*/
                    })
                break;
                case 'toggle-button':
                    filter.value = false;
                break;
                case 'searchbar':
                    filter.value = '';
                break;
                case 'rangeList':
                    filter.items.forEach((item) => {
                        item.selected = false;
                    })
                break;
                case 'radioList':
                    filter.items.forEach((item) => {
                        item.selected = false;
                    })
                break;
            }

        })
    },

    setFilterPanelState({dispatch, state, rootGetters}, fs) {
       
        if(!fs){
            dispatch('drawer/removeFromDrawer', {id: 'filters', drawer: state.filterPanelDrawer}, {root: true})
        } else {
            
            const drawerConfig = {id: 'filters', component: FilterPanel, drawer: state.filterPanelDrawer};
            if(rootGetters["raddar/isRaddar"]) {
                drawerConfig.attrs = {class: 'raddar-filters', 'feature-config-path': 'raddar.filterPanel'}
            }
            dispatch('drawer/addToDrawer', drawerConfig, {root: true})
        }
    },

    executeFilter({ getters , dispatch,rootGetters }) {
        if(sdid)return;
        
        sdid = setTimeout(() => {
            if (rootGetters['inlineDrawers/isFilterSortWindowOpen']) {
                sdid = null;
                return;
            }

            if (Object.keys(getters.searchQuery).length && rootGetters.isCTC ) //it is for CTC and tileSearch Only
            {
            dispatch("setTiledView", true, { root: true });
            }
            
            dispatch('search/filterProducts', getters.searchQuery, {root:true} )
            sdid = null;
        }, 1);

    },
      openAccordionSection({ commit }, sectionId) {
    commit('SET_ACTIVE_ACCORDION_SECTION', sectionId);
  },

  closeAccordionSection({ commit }, sectionId) {
    commit('REMOVE_ACTIVE_ACCORDION_SECTION', sectionId);
  },

  clearAccordionSections({ commit }) {
    commit('CLEAR_ACTIVE_ACCORDION_SECTIONS');
  }
}
const mutations = {
    SET_FILTER_DATA(state, filters) {
        state.filterData = filters;
    },
    SET_ACTIVE_ACCORDION_SECTION(state, sectionId) {
    if (!state.activeAccordionSections.includes(sectionId)) {
      state.activeAccordionSections.push(sectionId);
    }},
    REMOVE_ACTIVE_ACCORDION_SECTION(state, sectionId) {
    state.activeAccordionSections =
      state.activeAccordionSections.filter(id => id !== sectionId);
  },

  CLEAR_ACTIVE_ACCORDION_SECTIONS(state) {
    state.activeAccordionSections = [];
  },

  FILTERS_CLEARED(state) {
    state.filtersClearedAt = Date.now();
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
